import React, { useState } from "react";
import { Route, Redirect, useRouteMatch } from "react-router-dom";
import { ProtectedRoute } from "guards/ProtectedRoute";
import { SuperAdminGuard } from "guards/super-admin-guard";
import { AdminGuard } from "guards/admin-guard";
import { GradientLoader, PageError } from "shared/components";
import Home from "./Home/Index";
import ReportDetails from "./details";
import Layout from "Layout";
import CBNReport from "./cbn/cbn-report";
import TransactionDetails from "Transactions/TransactionDetails";
import TransactionOverview from "Transactions/Transaction-overview";
import GatewayReport from "./Home/Gateway";
import AgencyReport from "./Home/Agency";
// import ThirdPartyForm from "Settings/Channel/ThirdParty";

export default function Report() {
  const match = useRouteMatch();
  return (
    <>
      <Layout pageTitle='Report'>
        <>
          <ProtectedRoute
            path={`${match.path}/gateway`}
            guards={[SuperAdminGuard, AdminGuard]}
            component={GatewayReport}
            fallback={() => <PageError />}
          />

          <ProtectedRoute
            path={`${match.path}/agency`}
            guards={[SuperAdminGuard, AdminGuard]}
            component={AgencyReport}
            fallback={() => <PageError />}
          />

          <ProtectedRoute
            path={`${match.path}/details/:id`}
            guards={[SuperAdminGuard, AdminGuard]}
            component={ReportDetails}
            fallback={() => <PageError />}
          />
          <ProtectedRoute
            path={`${match.path}/gateway/transactions`}
            guards={[SuperAdminGuard, AdminGuard]}
            // component={TransactionOverview}
            render={() => <TransactionOverview url='gateway' />}
            fallback={() => <PageError />}
          />

          <ProtectedRoute
            path={`${match.path}/agency/transactions`}
            guards={[SuperAdminGuard, AdminGuard]}
            render={() => <TransactionOverview url='agency' />}
            fallback={() => <PageError />}
          />

          <ProtectedRoute
            path={`${match.path}/details/transactions/:id`}
            guards={[SuperAdminGuard, AdminGuard]}
            component={TransactionDetails}
            fallback={() => <PageError />}
          />
          {/* <ProtectedRoute
            path={`${match.path}/third-party`}
            guards={[SuperAdminGuard, AdminGuard]}
            component={ThirdPartyForm}
            fallback={() => <PageError />}
          /> */}

          <ProtectedRoute
            path={`${match.path}/cbnreport`}
            guards={[SuperAdminGuard, AdminGuard]}
            component={CBNReport}
            fallback={() => <PageError />}
          />

          {/* {match.isExact && <Redirect to={`${match.url}/home`} />} */}
        </>
      </Layout>
    </>
  );
}
